import { styled } from '@mui/material';

export const EmptyContainerWrapper = styled('div')({
  width     : '100%',
  margin    : 'auto',
  textAlign : 'center',
});

export const Title = styled('div')({
  marginTop : '10px',
  '& span'  : {
    fontFamily : 'Montserrat',
    fontWeight : '700',
    color      : '#231F20',
  },
});

export const Description = styled('div')(({ inline }) => ({
  ...(inline
    ? {
      marginTop : '10px',
    }
    : {
      marginTop    : '20px',
      marginBottom : '20px',
    }),
  '& span' : {
    width      : '75%',
    fontFamily : 'Montserrat',
    color      : '#231F20',
  },
}));
